import { Grid } from '@mui/material';
import PatientInformation from './PatientInformation';
import { PatientSearchFromEHRDetails } from '../Model';
import ParentAadhaarCard from './PatientAadhaarCard';
import PatientBirthCertificate from './PatientBirthCertificate';

type Props = {
  patientDetails: PatientSearchFromEHRDetails;
};

function PatientDetails({ patientDetails }: Props) {
  return (
    <Grid container direction='row' justifyContent='space-between' alignItems='stretch'>
      <Grid item xs={12} sm={12} md={6} lg={4} xl={4} sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0 } }}>
        <PatientInformation patientDetails={patientDetails} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={8} xl={8}>
        <Grid container direction='row' justifyContent='space-between' alignItems='flex-start'>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            sx={{ pr: { md: 2 }, mb: { xs: 2, md: 0 } }}
          >
            <ParentAadhaarCard />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <PatientBirthCertificate />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PatientDetails;
